import { DURACAO_MAX_DIGITOS } from "../hooks/nova-obra.duracao";
import { formatDataBr } from "../components/format-data";

export const digitos = (texto: string) => texto.replace(/\D/g, "").slice(0, DURACAO_MAX_DIGITOS);

export const paraNumero = (texto: string): number | null => {
  const somenteDigitos = digitos(texto);
  return somenteDigitos === "" ? null : Number(somenteDigitos);
};

export const formatDataBrOuVazio = (iso: string | null | undefined) =>
  iso ? formatDataBr(iso) : "";
